import { createFileRoute, Link } from '@tanstack/react-router';
import { useAuth } from '@clerk/clerk-react';
import { useEffect, useState } from 'react';

function ProCallbackPage() {
  const { isLoaded, isSignedIn } = useAuth();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      window.location.href = '/pro';
    }
  }, [isLoaded, isSignedIn]);

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), 20_000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoaded && isSignedIn) return null;

  return (
    <div className='min-h-screen bg-sky-light flex flex-col items-center justify-center gap-4 px-6'>
      <div className='text-center max-w-sm'>
        {!timedOut ? (
          <>
            <div className='text-4xl mb-4'>&#10003;</div>
            <h1
              className='text-xl font-semibold text-gray-900 mb-2'
              style={{
                fontFamily:
                  "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              }}
            >
              Email verified
            </h1>
            <p
              className='text-gray-600 text-sm mb-2'
              style={{
                fontFamily:
                  "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              }}
            >
              Go back to the tab where you started and you will be signed in
              automatically.
            </p>
            <div className='flex justify-center my-4'>
              <div className='animate-spin h-5 w-5 border-2 border-primary border-t-transparent rounded-full' />
            </div>
            <p className='text-xs text-gray-400'>
              If this tab doesn&apos;t redirect in a few seconds, go back to the
              original tab.
            </p>
          </>
        ) : (
          <>
            <h1
              className='text-xl font-semibold text-gray-900 mb-2'
              style={{
                fontFamily:
                  "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              }}
            >
              Return to sign in
            </h1>
            <p
              className='text-gray-600 text-sm mb-6'
              style={{
                fontFamily:
                  "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              }}
            >
              Your email was verified. Go back to the tab where you started, or
              sign in again below.
            </p>
            <Link
              to='/auth/pro/sign-in'
              className='inline-block px-6 py-2 bg-primary text-white rounded-xl font-semibold text-sm hover:opacity-90'
            >
              Sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export const Route = createFileRoute('/pro-callback')({
  component: ProCallbackPage,
});
